import Vue from "vue";
// axios
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "axios";
import store from "../store";
import { getUserData } from "@/auth/utils";
let accountType = getUserData() && getUserData().type ? getUserData().type : "";

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_BASE_URL,
  // timeout: 1000,
  headers: { Accept: "application/json" },
});
axiosIns.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.data && response.data.message) {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: response.data.message,
          icon: "CoffeeIcon",
          variant: "success",
        },
      });
    }
    return response;
  },
  function (error) {
    const code = parseInt(error.response && error.response.status);

    if (code == 409) {
      location.replace("/auth/user/email/verify");
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: `Please, verify your email!`,
          icon: "CoffeeIcon",
          variant: "warning",
        },
      });
    }
    if (code == 406) {
      location.replace("/partner-registration");
    }
    if (code == 402) {
      Vue.$toast(
        {
          component: ToastificationContent,
          props: {
            title: error.response.data.message,
            icon: "CoffeeIcon",
            variant: "danger",
          },
        },
        { position: "bottom-right" }
      );
    }
    if (code == 422) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        Object.keys(error.response.data.errors).length
      ) {
        Object.keys(error.response.data.errors).map((key) => {
          Vue.$toast(
            {
              component: ToastificationContent,
              props: {
                title: error.response.data.errors[key][0],
                icon: "CoffeeIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        });
      } else {
        Vue.$toast(
          {
            component: ToastificationContent,
            props: {
              title: `There is a problem.`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    }
    if (code == 404) {
      Vue.$toast(
        {
          component: ToastificationContent,
          props: {
            title: `Your Requested Url Could Not Be Found`,
            icon: "InfoIcon",
            variant: "warning",
          },
        },
        { timeout: 10000, position: "bottom-right" }
      );
      // location.replace("/404");
    }
    if (code == 403) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        Vue.$toast(
          {
            component: ToastificationContent,
            props: {
              title: error.response.data.message,
              icon: "InfoIcon",
              variant: "warning",
            },
          },
          { timeout: 10000, position: "bottom-right" }
        );
      }
    }
    // if (code == 500 || code == 501 || code == 502) {
    //   Vue.$toast(
    //     {
    //       component: ToastificationContent,
    //       props: {
    //         title: `server error`,
    //         icon: "InfoIcon",
    //         variant: "danger",
    //       },
    //     },
    //     { timeout: 10000, position: "bottom-right" }
    //   );
    //   // location.replace("/404");
    // }
    if (code == 401) {
      localStorage.removeItem("userData");

      store.dispatch("auth/setUserData", {});

      localStorage.removeItem("token");

      axiosIns.defaults.headers.common["Authorization"] = ``;
      location.replace("/login");
      Vue.$toast(
        {
          component: ToastificationContent,
          props: {
            title: "Your session has expired ",
            icon: "EditIcon",
            variant: "danger",
          },
        },
        { timeout: 10000, position: "bottom-right" }
      );
    }
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
